import Sticky from 'react-sticky-el';
import { useNavigate } from 'react-router-dom';
import { useFormContext } from 'framework/form';
import { Box } from '@mui/material';
import { CircularProgress } from '@mui/material';
import { Button } from 'framework/ui/mui-builder';

type OneStopButtonsLayoutProps = {
  onCancelAction?: Nullable<() => void>;
  isFixed?: boolean;
};

const OneStopButtonsLayout = ({ onCancelAction, isFixed = true }: OneStopButtonsLayoutProps) => {
  const navigate = useNavigate();
  const { submitForm, isSubmitEnabled, isLoadingArtifact } = useFormContext();

  const onCancel = onCancelAction || (() => navigate(-1));

  const buttons = (
    <Box display="flex" gap={1.25}>
      <Button
        data-testid="submit-btn"
        color="primary"
        type="submit"
        onClick={submitForm}
        disabled={!isSubmitEnabled || isLoadingArtifact}
      >
        {!isSubmitEnabled ? (
          <>
            <CircularProgress size={16} color="inherit" sx={{ mr: 1 }} />
            Submitting...
          </>
        ) : (
          'Submit'
        )}
      </Button>
      <Button
        data-testid="cancel-btn"
        variant="outlined"
        type="button"
        onClick={onCancel}
        disabled={!isSubmitEnabled || isLoadingArtifact}
      >
        Cancel
      </Button>
    </Box>
  );

  if (isFixed) {
    return (
      <Sticky mode="bottom" stickyClassName="sticky-buttons-element sticky">
        <Box sx={{ padding: 0 }}>{buttons}</Box>
      </Sticky>
    );
  }

  return <>{buttons}</>;
};

export default OneStopButtonsLayout;
